import cn from 'classnames';
import { Link } from 'react-router-dom';
import { ChatIconMenu } from '@shared/assets/index.ts';
import * as buttonStyles from '../styles.module.scss';
import * as st from './styles.module.scss';

type PT = {
  count: number;
};

export const CommentsSmallButton = ({ count }: PT) => {
  return (
    <Link to={'comments'} className={cn(buttonStyles.button, st.gap)}>
      <ChatIconMenu />
      <p>{count}</p>
    </Link>
  );
};
